import { jsx as o } from "react/jsx-runtime";
import { faInfoCircle as i, faCheckCircle as r, faExclamationTriangle as c, faCircleExclamation as e } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon as n } from "@fortawesome/react-fontawesome";
const t = ["info", "success", "warning", "error"], m = "info", l = {
  info: /* @__PURE__ */ o(n, { icon: i }),
  success: /* @__PURE__ */ o(n, { icon: r }),
  warning: /* @__PURE__ */ o(n, { icon: c }),
  error: /* @__PURE__ */ o(n, { icon: e })
};
export {
  m as DEFAULT_SEVERITY,
  l as defaultIconMapping,
  t as severity
};
